module.exports = __webpack_public_path__ + "img/project-21.cecf9899.png";